import React, { useState } from "react";

type TBooleanInputProps = {
    defaultValue: boolean;
    onUpdate: (value: boolean) => void;
    disabled?: boolean;
};

const BooleanInput = ({ defaultValue, onUpdate, disabled = false }: TBooleanInputProps) => {
    const [value, setValue] = useState(defaultValue);

    if (defaultValue !== value) {
        setValue(defaultValue);
    }

    const returnValue = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const val = evt.target.checked;
        setValue(val);
        onUpdate(val);
    };

    return <input type="checkbox" checked={value} onChange={returnValue} disabled={disabled} />;
};

export default BooleanInput;
